var _path, _rect, _polygon, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon2, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _polygon3, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polygon4, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "fill-dynamic-1",
    fill: "#9AE0EA",
    d: "M85.2,0.8v84.4H0.8V0.8H85.2z M64.9,21.1H21.1v43.8h43.8V21.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 28.9,
    y: 28.9,
    className: "fill-dynamic-2",
    fill: "#EEBAD4",
    width: 28.1,
    height: 28.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "icon-color-base",
    points: "9.6,11.1 7.6,11.1 7.6,7.6 11.1,7.6 11.1,9.6 9.6,9.6 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7.6,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "icon-color-base",
    points: "78.4,11.1 76.4,11.1 76.4,9.6 74.9,9.6 74.9,7.6 78.4,7.6 "
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 65.1,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 55.3,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 45.5,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 35.6,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 25.8,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 16,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "icon-color-base",
    points: "78.4,78.4 74.9,78.4 74.9,76.4 76.4,76.4 76.4,74.9 78.4,74.9 "
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76.4,
    className: "icon-color-base",
    width: 4.9,
    height: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "icon-color-base",
    points: "11.1,78.4 7.6,78.4 7.6,74.9 9.6,74.9 9.6,76.4 11.1,76.4 "
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 65.1,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 55.3,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 45.5,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 35.6,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 25.8,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 16,
    className: "icon-color-base",
    width: 2,
    height: 4.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.677ec2985607d43a32295333ada2f12f.svg";
export { ForwardRef as ReactComponent };